<custom-refund-teaser-pres
  [showAmount]="(config$ | async)?.showAmount"
  [showRefundAmount]="(showAmount$ | async)"
  [refundAmount]="(refundAmount$ | async)"
  [customRefundTeaserTitle]="customRefundTeaserTitle"
  [customRefundTeaserBody]="customRefundTeaserBody"
  [customRefundTeaserButtonLabel]="customRefundTeaserButtonLabel"
  [isPartialRefundEnabled]="(isPartialRefundEnabled$ | async)"
  (refund)="goToRefund()"
>
</custom-refund-teaser-pres>
